<template>
  <div class="animated fadeIn">
       
    <b-row>
      <b-col lg="12">
        <global-table
          :table-data="getData"
          :total-data="totalRows"
          :loading="loading"
          :per-page="100"
          :bordered="true"
          :table-detail="tableDetail"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="uploadOrderForm"
          :redirect-detail="true"
          :show-add-button="false"
          :upload-by-excell="true"
          :remove-button-bank-book="accessLevel"
          :search-by-bank="true"
          :search-by-transaction-date="true"
          :search-by-status-unposted="true"
          :list-bank="listBankFilter"
          :list-status-unposted="listStatusUnposted"
          caption="<i class='fa fa-align-justify'></i> Bank Transaction Listing"
          addButton="Tambah Transaksi"
          addExcellButton="Upload Transaksi Bank"
          @isEdit="isEdit"
          @removeForm="removeForm"
        ></global-table>

        <b-modal
          ref="uploadExcell"
          id="addModalsByExcell"
          header-border-variant="no-border text-center"
          footer-border-variant="no-border"
          footer-bg-variant="light"
          :no-close-on-backdrop="true"
          :no-close-on-esc="true"
          size="xl"
        >
          <div slot="modal-header" class="text-center">
            <h3 class="text-center">Form Upload Order</h3>
          </div>

          <b-form id="uploadOrderForm" validated novalidate>
            <template v-if="!formLoading">
              <b-row>
                <b-col sm="4">
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label-for="bank" label="Bank">
                        <model-select
                          id="bank"
                          :options="listBank"
                          v-model="uploadOrderForm.bank"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                          v-if="uploadOrderForm.bank === null"
                          class="invalid-feedback-custom"
                        >Jenis order harus di isi.</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label-for="year" label="Transaksi Tahun">
                        <model-select
                          id="year"
                          :options="listYear"
                          v-model="uploadOrderForm.year"
                          placeholder="-- Harap pilih salah satu --"
                        ></model-select>
                        <div
                          v-if="uploadOrderForm.year === null"
                          class="invalid-feedback-custom"
                        >Tahun harus di isi.</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12">
                      <b-form-group label-for="file" label="Upload Excel">
                        <b-form-file
                          ref="inputDocument"
                          accept=".xls, .xlsx, .csv"
                          @change="OnUploadSelect($event)"
                          v-model="uploadOrderForm.file"
                          required
                        ></b-form-file>
                        <div
                          v-if="uploadOrderForm.file === null || uploadOrderForm.file === undefined"
                          class="invalid-feedback-custom"
                        >Upload order anda dalam format excel.</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col sm="8">
                  <b-row>
                   <b-col>
                      <strong>
                        <small>Contoh format excel untuk upload transaksi, ketika akan upload. Pastikan formatnya sama. Untuk mutasi dan saldo, masukkan nilai tanpa koma</small>
                      </strong>
                      <b-table
                        v-if="uploadOrderForm.bank > 1"
                        v-bind:key="'a'"
                        :fields="fieldsExample"
                        :items="itemsExample"
                        :striped="true"
                        :bordered="true"
                      ></b-table>

                       <b-table
                        v-else
                        v-bind:key="'b'"
                        :fields="fieldsExample2"
                        :items="itemsExample2"
                        :striped="true"
                        :bordered="true"
                      ></b-table>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </template>
            <b-row v-else>
              <b-col>
                <loading></loading>
              </b-col>
            </b-row>
          </b-form>

          <div slot="modal-footer" class="float-right">
            <div v-if="!formLoading">
              <b-button type="button" size="sm" variant="danger" @click="cancelUpload">
                <i class="fa fa-undo"></i> Back
              </b-button>&nbsp;
              <b-button
                type="button"
                size="sm"
                variant="primary"
                @click="processUploadOrder"
                :disabled="$v.uploadOrderForm.$invalid"
              >
                <i class="fa fa-save"></i> Save
              </b-button>
            </div>
          </div>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import axios from "axios";
import globalTable from "../../templates/TableNew.vue";
import loading from "@/templates/Loading.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import { VueAutosuggest } from 'vue-autosuggest';

export default {
  name: "order",
  components: {
    globalTable,
    ModelSelect,
    loading,
    VueAutosuggest
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    accessLevel() {
      let employee_id = localStorage.getItem("nik");
      return (['MBS19040001', 'MBS19080016', 'MBS25020007', 'MBS25020005'].includes(employee_id)) ? true : false;
    }
  },
  data() {
    return {
      orders: [],
      bank: null,
      unpost: null,
      filteredOptions: [],
      listStatusUnposted: [],
      suggestions: [
        {
          data: [],
        },
      ],
      fields: [
        { key: "batch_code", label: "Batch Code", class: "width-150" },
        { key: "bank_account_name", label: "BANK", class: "width-170" },
        { key: "transaction_date", label: "Tanggal Transaksi", class: "width-170", sortable: true },
        { key: "mutation", label: "Mutasi", class: "width-200" },
        { key: "total_mutation", label: "Total", class: "width-200" },
        { key: "mutation_type", label: "Tipe", class: "width-80" },
        { key: "description_transaction", label: "Deskripsi" },
        { key: "action", class: "text-center width-100" }
      ],
      fieldsExample: [
        { key: "transaction_date", label: "Date" },
        { key: "description", label: "Desc" },
        { key: "mutation", label: "Amount Type" }
      ],
      itemsExample: [
        { transaction_date: "20/05", description: "TRSF E-BANKING DB 2005/FTSCY/WS95051 190000000.00 CAHAYA BOGA DAIRYN", mutation: "20000000.01 CR" },
        { transaction_date: "20/05", description: "TRSF E-BANKING CR 2505/FTSCY/WS95051 206255050.00 RATANA MAKMUR BAHA", mutation: "1000000.00 DB" },
        { transaction_date: "Kolom A", description: "Kolom B", mutation: "Kolom C" }
      ],
    fieldsExample2: [
        { key: "transaction_date", label: "Date" },
        { key: "description", label: "Desc" },
        { key: "db", label: "DB" },
        { key: "cr", label: "CR" }
      ],
      itemsExample2: [
        { transaction_date: "20/05", description: "TRSF E-BANKING DB 2005/FTSCY/WS95051 190000000.00 CAHAYA BOGA DAIRYN", db: "20000000.01", cr: "" },
        { transaction_date: "20/05", description: "TRSF E-BANKING CR 2505/FTSCY/WS95051 206255050.00 RATANA MAKMUR BAHA", db: "", cr: "1000000.00" },
        { transaction_date: "Kolom A", description: "Kolom B", db: "Kolom C", cr: "Kolom D" }
      ],
    
    
      uploadOrderForm: { file: null, bank: null, year: null },
      loading: true,
      formLoading: false,
      listBank: [],
      listBankFilter: [],
      listCategory: [],
      listYear: [],
      uploadListExcell: ["xls", "xlsx", "csv"],
      totalRows: "",
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  validations: {
    uploadOrderForm: {
      file: { required },
      bank: { required },
      year: { required }
    }
  },
  methods: {
    getData: function(ctx) {
      this.loading = true;
      let response = axios.post('web/bank_book/all', ctx);
      return response.then((data) => {
        const items = data.data.data;
        this.totalRows = data.data.total_rows;
        this.loading=false;
        return(items)
      }).catch(error => {
        this.expired(error);
        this.loading=false;
        return []
      })
    },
    init: function() {
      this.uploadOrderForm.file = null;
      this.uploadOrderForm.bank = null;
      this.getDropdown();
      // this.getData();
    },
    onSelect: function(event) {
      //console.log(event);
    },
    getDropdown: function() {
      this.axios
        .get("web/dropdown/bank-book-transaction")
        .then(response => {
          this.listBank = response.data.bank_account;
          this.listCategory = response.data.transaction_category;
          this.listStatusUnposted = response.data.status;
          this.listBankFilter = response.data.bank_account_filter;
          this.listYear = response.data.year;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    removeForm: function(e) {
      if (confirm("Apakah anda ingin menghapus SPKB pada transaksi ini ??")) {
        this.formLoading = true;
        this.axios
          .put("web/bank_book/remove-spkb-transaction", e)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Remove Transaction",
                message: response.data.message
              });
              window.location.reload();
            } else {
               this.showErrorNotification({
                title: "Remove Transaction",
                message: response.data.message
              });
              this.resetFormUploadForm();
            }
          })
          .catch(error => {
            this.expired(error, "Remove Transaction");
            this.resetFormUploadForm();
          })
          .finally(() => {
            this.resetFormUploadForm();
          });
      }
    },
    resetFormUploadForm: function() {
      this.formLoading = false;
      this.$refs["inputDocument"].reset();
      this.uploadOrderForm.file = null;
      this.uploadOrderForm.bank = null;
      this.uploadOrderForm.year = null;
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    cancelUpload: function() {
      this.resetFormUploadForm();
      this.$refs.uploadExcell.hide();
    },
    OnUploadSelect: function(event) {
      const file = event.target.files[0];
      const fileArray = file.name.split(".");
      const totalArray = fileArray.length - 1;
      if (this.uploadListExcell.includes(fileArray[totalArray])) {
        this.uploadOrderForm.file = event.target.files[0];
      } else {
        this.resetFormUploadForm();
      }
    },
    processUploadOrder: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan order ?")) {
        this.formLoading = true;
        let uploadOrder = new FormData();
        uploadOrder.append("employee_id", localStorage.getItem("employee_id"));
        uploadOrder.append("file", this.uploadOrderForm.file);
        uploadOrder.append("bank", this.uploadOrderForm.bank);
        uploadOrder.append("year", this.uploadOrderForm.year);
        this.axios
          .post("web/bank_book/upload-file/", uploadOrder)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Add Transaction",
                message: response.data.message
              });
              window.location.reload();
            } else {
               this.showErrorNotification({
                title: "Upload Transaction",
                message: response.data.message
              });
              this.resetFormUploadForm();
            }
          })
          .catch(error => {
            this.expired(error, "Upload Transaction");
            this.resetFormUploadForm();
          })
          .finally(() => {
             this.$refs.uploadExcell.hide();
            this.resetFormUploadForm();
          });
      }
      //console.log(this.uploadOrderForm);
    },
    submitAdd: function(evt) {
      evt.preventDefault();

      if (confirm("Apakah anda ingin menambahkan order ?")) {
        let order = this.orderForm;
        this.formLoading = true;
        order.employee_id = localStorage.getItem("employee_id");
        this.axios
          .post("web/order/add/", order)
          .then(response => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Add Order",
                message: response.data.message
              });
            }
            this.cancelAdd();
            this.$router.push({ path: "all/detail/" + response.data.id });
          })
          .catch(error => {
            this.expired(error, "Tambah Order");
            this.resetForm();
          })
          .finally(() => {});
      }
    },
    isEdit: function(flag) {
      return flag;
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.orderForm.customer_id = null
        this.customers.text = null;
        this.customers.value = null;
        return;
      } else {
        this.orderForm.customer_id = item.item.value;
        this.customers.text = item.item.text;
        this.customers.value = item.item.value;
     }
    },
    focusMe: function(item){
       if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        this.orderForm.customer_id = null
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-customer/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    },
  },
  mounted() {
    this.init();
  }
};
</script>